import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseForm from "./warehouseComponents/WarehouseForm";

import {
  useGetWarehouseDetailQuery,
  useUpdateWarehouseMutation,
} from "store/services/warehouseApi";

import { useAppMeta } from "hooks";

const WarehouseEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehouses", path: "/app/crm/warehouse/list" },
    { title: "Edit Warehouse" },
  ];

  // RTK Query
  const {
    data: warehouseDetail,
    isLoading: loadingWarehouse,
    error,
  } = useGetWarehouseDetailQuery(id);

  const [updateWarehouse, { isLoading: updatingWarehouse }] =
    useUpdateWarehouseMutation();

  // methods
  const handleUpdateWarehouse = async (data) => {
    const payload = {  id, ...data };

    try {
      await updateWarehouse(payload).unwrap();
      toast.success("Warehouse successfully updated!");
      navigate(`/app/crm/warehouse/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Warehouse!"
      );
    }
  };

  useAppMeta("Edit Warehouse");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingWarehouse || updatingWarehouse}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <WarehouseForm
          isBusy={loadingWarehouse || updatingWarehouse}
          warehouseDetail={warehouseDetail}
          onSubmit={handleUpdateWarehouse}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseEditScreen;
